/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Sendinvoicedaysinadvance4Inputs */

const en__field_sendinvoicedaysinadvance4 = /** @type {(inputs: _Field_Sendinvoicedaysinadvance4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`invoices are going to be sent x days in advance`)
};

const de__field_sendinvoicedaysinadvance4 = /** @type {(inputs: _Field_Sendinvoicedaysinadvance4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rechnungen werden X Tage vor Beginn gesendet`)
};

/**
* | output |
* | --- |
* | "invoices are going to be sent x days in advance" |
*
* @param {_Field_Sendinvoicedaysinadvance4Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_sendinvoicedaysinadvance4 = /** @type {((inputs?: _Field_Sendinvoicedaysinadvance4Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Sendinvoicedaysinadvance4Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_sendinvoicedaysinadvance4(inputs)
	return de__field_sendinvoicedaysinadvance4(inputs)
});
export { _field_sendinvoicedaysinadvance4 as "_field_sendInvoiceDaysInAdvance" }